export default __webpack_public_path__ + "static/media/receipt.24c49884.svg";